module.exports = __webpack_public_path__ + "static/coupon-5e5b27e75fab5f8102b43e08a8915ce0.png";